import {Component, Optional, Inject} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

export class DisbursementRequestData {
    constructor(public currentBalance, public requestedAmount, public displayName) {}
}

@Component({
    selector: 'disbursement-request-confirmation-modal',
    templateUrl: './disbursement-request-confirmation-modal.html',
})

export class DisbursementRequestConfirmationModalComponent {

    // Gets or sets the current balance
    public currentBalance: number;

    // Gets or sets the requested amount
    public requestedAmount: number;

    // Gets or sets the new account balance
    public newAccountBalance: number;

    // Gets or sets the display name
    public displayName: string;

    /**
     * Constructs the modal dialog
     * @param public dialog The dialog reference and dialog data
     * @param modal
     * @param viewContainerRef
     * @param formBuilder
     */
    constructor(public dialogRef: MatDialogRef<DisbursementRequestConfirmationModalComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: DisbursementRequestData) {
        this.currentBalance = this.data.currentBalance;
        this.requestedAmount = this.data.requestedAmount;
        this.displayName = this.data.displayName;
        this.initPageData();
    }

    /**
     * Initializes page data
     */
    private initPageData() {

        this.newAccountBalance = this.currentBalance - this.requestedAmount;
    }

    /**
      * Closes the modal dialog and returns success response
      */
    public submit() {
        this.dialogRef.close(true);
    }

    /**
     * Pops up modal dialog to confirm the cancel if any unsaved data is present, and cancels if desired.
     */
    public cancel() {
        this.confirmCancel();
    }

    /**
     * Closes the modal dialog with no return result
     */
    public confirmCancel() {
        this.dialogRef.close();
    }
}
